import { Link } from "react-router-dom";
import markPerlman from "../assets/MarkPerlman.webp";

export default function Consultants() {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white border border-border rounded-2xl px-11 py-10 max-[680px]:px-6 max-[680px]:py-7">
        <h1 className="font-display text-[30px] font-semibold text-primary-dark mb-2.5 leading-tight">Consultants &amp; Trainers</h1>
        <p className="text-sm text-[#555] leading-relaxed max-w-[680px]">
          The following list identifies professionals trained and recognized to represent the MA&amp;PA Program in their geographical area, providing training, public speaking, and consultation on successful program implementation.
        </p>
      </div>

      <div className="text-[10px] font-medium tracking-[0.1em] uppercase text-[#999] px-1 -mb-2">Program Author</div>

      <div className="bg-white border border-border rounded-2xl p-8 flex gap-8 items-start max-[680px]:flex-col max-[680px]:p-6">
        <div className="flex flex-col gap-3 flex-1">
          <div className="text-[18px] font-semibold text-[#1a1a1a]">Mark Perlman, MA</div>
          <div className="text-[13px] text-primary font-medium italic">Author of the MA &amp; PA Program</div>
          <p className="text-[13px] text-[#555] leading-relaxed">
            Mark has 35 years of experience working with parents, children and families in strengthening the family bond. He authored <a href="https://www.nurturingfathers.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">The Nurturing Father's Program</a>, a 13-week parenting curriculum for men utilized by thousands of fathers across organizations such as Prevent Child Abuse, Head Start, Milwaukee Fatherhood Initiative, North Carolina Department of Corrections, and State of Michigan. Mark also authored the MA &amp; PA Program that helps couples parent successfully as a team. He is the past Executive Director of the Family Counseling Center, The Child Protection Center and Fathers United Network (FUN) of Sarasota, Florida. He has served on the Florida Commission on Responsible Fatherhood, Commission on Marriage and Family Support, and currently on the Governor's Child Abuse Prevention and Permanency Council.
          </p>
          <a href="mailto:info@nurturingfathers.com" className="text-[13px] text-primary no-underline hover:underline">Contact Mark →</a>
        </div>
        <img src={markPerlman} alt="Mark Perlman" className="w-48 h-56 rounded-2xl object-cover object-top shrink-0 max-[680px]:w-full max-[680px]:h-64" />
      </div>

      <div className="text-[10px] font-medium tracking-[0.1em] uppercase text-[#999] px-1 -mb-2">Certified Consultant-Trainers</div>

      <div className="bg-white border border-border rounded-2xl px-10 py-9 flex flex-col gap-6 max-[680px]:px-6">

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Larry Hemingway, Sr. <span className="text-primary font-normal italic">(Master Trainer)</span></div>
          <div className="text-[13px] text-[#555]">Springfield Urban League</div>
          <div className="text-[13px] text-[#555]">100 N. 11th Street</div>
          <div className="text-[13px] text-[#555]">Springfield, IL 62703</div>
          <div className="text-[13px] text-[#555]">Tel: 217-789-0830, 217-553-9582 cell</div>
          <div className="text-[13px] text-[#555]">Fax: 217-789-9838</div>
          <a href="mailto:lhemingway@springfieldul.org" className="text-[13px] text-primary no-underline hover:underline">lhemingway@springfieldul.org</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Duane M. Wilson <span className="text-primary font-normal italic">(Master Trainer)</span></div>
          <div className="text-[13px] text-[#555]">1613 Colorado Drive East Lansing, MI 48823</div>
          <div className="text-[13px] text-[#555]">(517) 241-7050</div>
          <a href="mailto:wilsond6@michigan.gov" className="text-[13px] text-primary no-underline hover:underline">wilsond6@michigan.gov</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Bruce M Sukennikoff <span className="text-primary font-normal italic">(Master Trainer)</span></div>
          <div className="text-[13px] text-[#555]">Nurturing Dad's and Nurturing Couples</div>
          <div className="text-[13px] text-[#555]">Parenting Programs of Charlotte Behavioral Health Care</div>
          <div className="text-[13px] text-[#555]">21450 Gibralter Dr,</div>
          <div className="text-[13px] text-[#555]">Port Charlotte, FL 33952</div>
          <div className="text-[13px] text-[#555]">Office #941-764-7070</div>
          <div className="text-[13px] text-[#555]">Fax #941-764-7090</div>
          <div className="text-[13px] text-[#555]">Cell #941-815-0342</div>
          <a href="mailto:Bsukennikoff@ccmhs.org" className="text-[13px] text-primary no-underline hover:underline">Bsukennikoff@ccmhs.org</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Lula Griggs</div>
          <div className="text-[13px] text-[#555]">Child Development Council of Brazoria County</div>
          <div className="text-[13px] text-[#555]">651 West Miller St.</div>
          <div className="text-[13px] text-[#555]">Angleton, TX 77515</div>
          <div className="text-[13px] text-[#555]">979 849 1881</div>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Larry Griggs Sr.</div>
          <div className="text-[13px] text-[#555]">Child Development Council of Brazoria County</div>
          <div className="text-[13px] text-[#555]">651 West Miller St.</div>
          <div className="text-[13px] text-[#555]">Angleton, TX 77515</div>
          <div className="text-[13px] text-[#555]">979 849 1881</div>
          <a href="mailto:lgriggs@headstartbc.org" className="text-[13px] text-primary no-underline hover:underline">lgriggs@headstartbc.org</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Cheryle Worthen</div>
          <div className="text-[13px] text-[#555]">Healthy Families Charlotte County</div>
          <div className="text-[13px] text-[#555]">Of Charlotte Behavioral Health Care</div>
          <div className="text-[13px] text-[#555]">21450 Gibralter Dr. Port Charlotte, FL 33952</div>
          <div className="text-[13px] text-[#555]">(941) 629-6477 Phone &nbsp; (941) 629-6455 Fax</div>
          <a href="https://www.healthyfamiliesfla.org" target="_blank" rel="noopener noreferrer" className="text-[13px] text-primary no-underline hover:underline">www.healthyfamiliesfla.org</a>
          <a href="https://www.cbhcfla.org" target="_blank" rel="noopener noreferrer" className="text-[13px] text-primary no-underline hover:underline">www.cbhcfla.org</a>
          <a href="mailto:HealthyFamiliesCharlotte@embarqmail.com" className="text-[13px] text-primary no-underline hover:underline">HealthyFamiliesCharlotte@embarqmail.com</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">William Goodwin</div>
          <div className="text-[13px] text-[#555]">Newport News Healthy Families Initiative</div>
          <div className="text-[13px] text-[#555]">6060 Jefferson Ave</div>
          <div className="text-[13px] text-[#555]">Newport News, VA 23605</div>
          <div className="text-[13px] text-[#555]">757 926 6659</div>
          <a href="mailto:wgh700@eastern.dss.state.va.us" className="text-[13px] text-primary no-underline hover:underline">wgh700@eastern.dss.state.va.us</a>
        </div>

        <div className="flex flex-col gap-0.5 pb-6 border-b border-border">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Julie Kepler</div>
          <div className="text-[13px] text-[#555]">CACS Head Start</div>
          <div className="text-[13px] text-[#555]">101 E Willow St.</div>
          <div className="text-[13px] text-[#555]">Lansing, MI 48906</div>
          <div className="text-[13px] text-[#555]">517-482-1504 tel.</div>
          <div className="text-[13px] text-[#555]">517-482-1448 fax</div>
          <a href="mailto:julie.kepler@cacsheadstart.org" className="text-[13px] text-primary no-underline hover:underline">julie.kepler@cacsheadstart.org</a>
        </div>

        <div className="flex flex-col gap-0.5">
          <div className="text-[14px] font-semibold text-[#1a1a1a]">Barry Kaufman</div>
          <div className="text-[13px] text-[#555]">CACS Head Start</div>
          <div className="text-[13px] text-[#555]">101 E. Willow St.</div>
          <div className="text-[13px] text-[#555]">Lansing, MI 48906</div>
          <div className="text-[13px] text-[#555]">517-482-1504 tel.</div>
          <div className="text-[13px] text-[#555]">517-482-1448 fax</div>
        </div>

      </div>

      {/* <div className="bg-gradient-to-br from-primary to-primary-dark rounded-2xl px-9 py-7 flex justify-between items-center gap-6 max-[680px]:flex-col">
        <div>
          <h3 className="font-display text-[18px] text-white mb-1.5">Become a Certified Consultant-Trainer</h3>
          <p className="text-[13px] text-white/75 leading-snug max-w-[480px]">
            Interested in implementing the MA &amp; PA Program in your community? Attend a Consultant/Trainer Workshop and become certified to train others. Workshops are offered jointly with the Nurturing Fathers Program.
          </p>
        </div>
        <Link to="/contact" className="bg-white text-primary text-[13px] font-medium px-5 py-2.5 rounded-[20px] transition-opacity hover:opacity-90 no-underline whitespace-nowrap">
          Learn More
        </Link>
      </div> */}

      <div className="text-[10px] font-medium tracking-[0.1em] uppercase text-[#999] px-1 -mb-2">What Consultants Say</div>

      <div className="grid grid-cols-3 gap-3 max-[680px]:grid-cols-1">
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">The MA &amp; PA Program fills a critical gap — it meets couples where they are and gives them real tools for family life.</p>
          <div className="text-[11px] text-primary font-medium">Certified Consultant-Trainer, Florida</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">I've implemented this program in three Head Start sites. The couple dialogue format is unlike anything else out there.</p>
          <div className="text-[11px] text-primary font-medium">Facilitator, Georgia</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">Having it available in Spanish opened doors to families we could never reach before.</p>
          <div className="text-[11px] text-primary font-medium">Consultant-Trainer, Texas</div>
        </div>
      </div>
    </div>
  );
}
